import styled from 'styled-components'

export const OptionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`
